import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

import { Config, internalPrinter, Lang, salesItemsLayout, Theme } from './configTypes';

const initialState: Config = {
  lang: 'en',
  theme: 'light',
  online: true,
  salesItemsLayout: 'card',
  internalPrinter: null,
  syncing: false,
  currency: null,
  pin: null,
};
const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setLang(state, action: PayloadAction<Lang>) {
      state.lang = action.payload;
    },
    setTheme(state, action: PayloadAction<Theme>) {
      state.theme = action.payload;
    },
    setOnline(state, action: PayloadAction<boolean>) {
      state.online = action.payload;
    },
    setCurrency(state, action: PayloadAction<string>) {
      state.currency = action.payload;
    },
    setSalesItemsLayout(state, action: PayloadAction<salesItemsLayout>) {
      state.salesItemsLayout = action.payload;
    },
    setPin(state, action: PayloadAction<string>) {
      state.pin = action.payload;
    },
    setInternalPrinter(state, action: PayloadAction<internalPrinter>) {
      state.internalPrinter = action.payload;
    },

    setSyncing(state, action: PayloadAction<boolean>) {
      state.syncing = action.payload;
    },
  },
});

export const {
  setLang,
  setTheme,
  setOnline,
  setCurrency,
  setPin,
  setSalesItemsLayout,
  setInternalPrinter,
  setSyncing,
} = configSlice.actions;

export const selectLang = (state: RootState) => state.config.lang;
export const selectTheme = (state: RootState) => state.config.theme;
export const selectOnline = (state: RootState) => state.config.online;
export const selectCurrency = (state: RootState) => state.config.currency;
export const selectPin = (state: RootState) => state.config.pin;
export const selectSyncing = (state: RootState) => state.config.syncing;
export const selectSalesItemsLayout = (state: RootState) => state.config.salesItemsLayout;
export const selectInternalPrinter = (state: RootState) => state.config.internalPrinter;

export default configSlice.reducer;
